import GeometryBuffer from './GeometryBuffer';
import * as vec3 from './glMatrix/vec3';





class BoxGeometryBuffer extends GeometryBuffer {
	
	constructor(gl, options) {

		super(gl, 4.);

		options = Object.assign({},{
			width:  10,
			height: 10,
			depth:  10,
			widthSegments:  1,
			heightSegments: 1,
			depthSegments:  1
		}, options);

		// buffers
		var indices  = [];
		var vertices = [];
		var normals  = [];
		var uvs      = [];
		var colors   = []

		var numberOfVertices = 0;
		var vertexCounter = 0;

		function buildPlane( u, v, w, udir, vdir, width, height, depth, gridX, gridY ) {

			vertexCounter = 0;

			var segmentWidth  = width / gridX;
			var segmentHeight = height / gridY;
			var widthHalf     = width / 2;
			var heightHalf    = height / 2;
			var depthHalf     = depth / 2;
			var gridX1        = gridX + 1;
			var gridY1        = gridY + 1;
			var ix, iy;

			var vector = vec3.create();

			// generate vertices, normals and uvs

			for ( iy = 0; iy < gridY1; iy ++ ) {

				var y = iy * segmentHeight - heightHalf;

				for ( ix = 0; ix < gridX1; ix ++ ) {

					var x = ix * segmentWidth - widthHalf;

					vector[ u ] = x * udir;
					vector[ v ] = y * vdir;
					vector[ w ] = depthHalf;
					vertices.push( vector[0], vector[1], vector[2] );

					vector[ u ] = 1.;
					vector[ v ] = 1.;
					vector[ w ] = 1.;

					vector[ u ] = 0;
					vector[ v ] = 0;
					vector[ w ] = depth > 0 ? 1 : -1;
					normals.push( vector[0], vector[1], vector[2] );

					uvs.push( ix / gridX, 1 - ( iy / gridY ) );
					
					colors.push( 1, 1, 1 );

					vertexCounter += 1;

				}

			}

			for ( iy = 0; iy < gridY; iy ++ ) {
				for ( ix = 0; ix < gridX; ix ++ ) {
					var a = numberOfVertices + ix + gridX1 * iy;
					var b = numberOfVertices + ix + gridX1 * ( iy + 1 );
					var c = numberOfVertices + ( ix + 1 ) + gridX1 * ( iy + 1 );
					var d = numberOfVertices + ( ix + 1 ) + gridX1 * iy;
					// faces
					indices.push( a, b, d );
					indices.push( b, c, d );
				}
			}

			numberOfVertices += vertexCounter;
		}


		// build each side of the box geometry
		buildPlane( 2, 1, 0, - 1, - 1, options.depth, options.height,   options.width,  Math.floor(options.depthSegments), Math.floor(options.heightSegments) ); // px
		buildPlane( 2, 1, 0,   1, - 1, options.depth, options.height, - options.width,  Math.floor(options.depthSegments), Math.floor(options.heightSegments) ); // nx
		buildPlane( 0, 2, 1,   1,   1, options.width, options.depth,    options.height, Math.floor(options.widthSegments), Math.floor(options.depthSegments)  ); // py
		buildPlane( 0, 2, 1,   1, - 1, options.width, options.depth,  - options.height, Math.floor(options.widthSegments), Math.floor(options.depthSegments)  ); // ny
		buildPlane( 0, 1, 2,   1, - 1, options.width, options.height,   options.depth,  Math.floor(options.widthSegments), Math.floor(options.heightSegments) ); // pz
		buildPlane( 0, 1, 2, - 1, - 1, options.width, options.height, - options.depth,  Math.floor(options.widthSegments), Math.floor(options.heightSegments) ); // nz


		// build geometry
		this.length = numberOfVertices;

		this.addAttribute( 'index',    new Uint16Array(  indices  ), 1 );
		this.addAttribute( 'position', new Float32Array( vertices ), 3 );
		this.addAttribute( 'normal',   new Float32Array( normals  ), 3 );
		this.addAttribute( 'uv',       new Float32Array( uvs      ), 2 );
		this.addAttribute( 'color',   new Float32Array( colors   ), 3 );

		this.indices = indices
		this.vertices = vertices
		this.normals = normals
		this.uvs = uvs
		this.colors = colors

		this.computeBoudingBox()
		
	}

}

export default BoxGeometryBuffer;